export default "__VITE_ASSET__18101588__"